<template>
<div>
  <div class="accountExtract wrap-scroll">
      <div v-if="!!selectCard">
        <div class="wrap-card-w">
            <header class="wrap-card-header">
                选择银行卡
                <a href="javascript:void(0);" class="f-rt color-link" @click="dialogVisible = true">限额说明</a>
            </header>
            <div class="wrap-card-box" @click="openSelectBox">
                <div class="card card-jianshe">
                    <p class="card-name">
                        <i class="icon-banklogo"></i> {{selectCard.other_branch_name}}
                    </p>
                    <p class="card-num">{{selectCard.other_acct_no}}</p>
                    <div class="el-rt">
                        <i class="icon-arrow-rt"></i>
                    </div>
                </div>
            </div>
        </div>
        <div class="list list-input list-full-rt">
            <section class="input-amount">
                <label class="item item-md">
                    <span class="label-lg">充值金额</span>
                    <input  v-model="amount" name="amount" type="number" data-vv-as="金额"  :disabled="disableAmountInput" placeholder="0.00" autocomplete="off" class="input" @focus="amountInputWrong = false">
                    </label>
                    <div :class="{ 'wrong_amount': amountInputWrong, 'item bar-notice-inset': true, 'bar-inset-lg': true }" >
                        <div v-if="isBusinessRecharge">
                             单笔限额<span class="num">{{amount}}</span> 元，该卡本次最多可充值
                             <span class="num">{{selectCard.daily_single_limit}}</span>元
                        </div>

                        <div v-if="!isBusinessRecharge && !amountInputWrong">
                             单笔最低 <span class="num">{{min_recharge_amount}}</span> 元起，该卡本次最多可充值
                             <span class="num">{{selectCard.daily_single_limit}}</span>元
                        </div>
                        <p v-if="amountInputWrong">
                            {{errorText}}
                        </p>
                    </div>
                </section>
        </div>
        <div class="wrap-btn-foot">
            <button v-bind:disabled="chargable" class="btn-md" @click="recharge">下一步</button>
        </div>
        <p class="card-tips">到账时间：24小时内到账</p>
      </div>
      <div class="item item-lg item-add" @click="bindCard" v-if="!selectCard && !isBusinessRecharge">
          <i class="icon-w-add"></i>使用新卡付款
      </div>
  </div>
  <div class="mask-md" v-if="showBox">
    <div transition="catapult" class="wrap-pop-bottom">
        <div class="wrap-pop-title">
            <span class="icon-error" @click="closeSelectBox">X</span> 选择付款方式
         
        </div>
        <div class="list list-card">
              <label class="item item-db item-checkbox" v-for="(card,index) in cardList"
                     :key="index" @click.prevent="selectCardAction(index)">
                  <span class="icon-banklogo el-lt banklogo-jianshe"></span>
                  <h3 class="bank-name">{{card.other_branch_name}}   {{card.other_acct_type|cardType}}  (尾号{{card.other_acct_no|lastFour}})</h3>
                  <span class="checkbox el-rt">
                      <input type="radio" name="card"  v-bind:value="index" checked v-if="card.default_flag == 'Y'">
                  </span>
              </label>
                <div class="item item-lg item-add" @click="bindCard">
                    <i class="icon-w-add"></i>使用新卡付款
                </div>
            </div>
        </div>
    </div>
    <dialog-limit v-if="selectCard" :visible="dialogVisible" :selectCard="selectCard" @closeDialog="dialogVisible = false"></dialog-limit>
</div>
</template>

<script>
import { Indicator } from 'mint-ui';
import { Toast } from 'mint-ui';
import {Get,Post} from '@/utils/http';
import { MessageBox } from 'mint-ui';
import dialogLimit from '@/components/dialog_daily_limit';
export default {
  name: 'Recharge',
  data () {
    return {
        dialogVisible: false,
        min_recharge_amount:'',
        wallet_id:'',
        amountInputWrong:false,
        disableAmountInput:false,
        amount:"",
        errorText:'金额不正确',
        showBox:false,
        bill_id:'',
        cardList: [
        //   {
        //      "binding_id": "e798bd49900e466cbf5a149a87205bf4",
        //      "other_acct_no": "6200********2710",
        //      "other_acct_type": "10",
        //      "other_branch_name": "工商银行",
        //      "other_branch_no": "102100099996",
        //      "daily_single_limit": "50000.00",
        //      "daily_limit": "50000.00",
        //      "default_flag": "N",
        //      "open_super_flag": "N"
        //   }
        //   ,
        //   {
        //       "binding_id": "12356",           //绑定ID
        //       "other_acct_no": "256515618548468546546",         //银行卡号(脱敏处理)
        //       "other_acct_type": 20,       //银行卡类型, 10: 借记卡, 20: 贷记卡; 30: 准贷记卡
        //       "other_branch_name": "中国银行2",     //银行名称
        //       "other_branch_no": "654684684564654",       //银行联行号
        //       "daily_single_limit":"6500",    //单笔限额, 单位元
        //       "daily_limit": "56000",           //每日限额, 单位元
        //       "default_flag": true,       //默认卡标记, Y: 是; N: 否
        //       "open_super_flag": ""        //关联二类户, Y: 是; N: 否
        //   }
      ],
    }
  },
   computed: {

    // 选中的银行卡
    selectCard() {
        return this.cardList.find((e)=>{
          return e.default_flag == "Y";
        })
    },

    // 从业务过来的充值
    isBusinessRecharge(){
        return this.bill_id !== '';
    },

    // 是否可充值
    chargable(){
        return this.amount == ''
    },
  },
  beforeMount(){

      // url参数有bill_id时，获取固定金额
      let queryObj = this.$route.query;
      if(typeof(queryObj.bill_id)!=='undefined'){
          this.bill_id = queryObj.bill_id;
          this.getFixedAmount();
      }
  },
   mounted() {
    Indicator.open();
    this.wallet_id = this.$route.params.wallet_id;
    this.getWalletInfo();
   
  },
   filters: {
    cardType(type){
      switch(type){
        case '10':   return '借记卡'; break;
        case '20':   return '贷记卡'; break;
        case '30':    return '准贷记卡';break;
        // default:  return s;
      }
    },
    lastFour(s){
      return s.substr(-4)
    }
  },
   methods: {
    
    sub(arg1, arg2) {
        let r1, r2, m, n;
        try {
            r1 = arg1.toString().split(".")[1].length;
        }
        catch (e) {
            r1 = 0;
        }
        try {
            r2 = arg2.toString().split(".")[1].length;
        }
        catch (e) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
        n = (r1 >= r2) ? r1 : r2;
        return ((arg1 * m - arg2 * m) / m).toFixed(n);
    },

    // 获取钱包信息
    getWalletInfo(){
        const url = '/v1/person/wallet/info';
        const params = {
            wallet_id:this.wallet_id
        }
        Post(url,params).then((res)=>{
          this.min_recharge_amount = res.min_recharge_amount;
          this.getCardList();
        }).catch((error)=>{
            Indicator.close();
            if(error.code == 28126){
                 MessageBox({
                    title: '',
                    message: '您还未设置钱包密码',
                    showCancelButton: false,
                    showConfirmButton:true,
                    closeOnClickModal:false,
                    confirmButtonText:'立即设置'
                    }).then(action => {                     
                        this.setPassword();                    
                    })
            }else{
                Toast({
                     message: "code:"+error.code+" message:"+error.msg,
                     duration: 3000
                 });
            }
        })
    },

    // 设置钱包密码
    setPassword(){
        const url = '/v1/person/wallet/password/set';
        const params = {
            wallet_id:this.wallet_id,
            redirect:window.location.href
        }
        Indicator.open();
        Post(url,params).then((res)=>{
            Indicator.close();
            window.location = res.pwd_set_url;
        }).catch((error)=>{
            Toast({
                    message: "code:"+error.code+" message:"+error.msg,
                    duration: 3000
                });
        })
    },

    // 获取银行卡列表
    getCardList() {
        const url = '/v1/person/wallet/card/list';
        const params = {
            wallet_id:this.wallet_id
        }
        Post(url,params).then((res)=>{
            this.cardList = res; 
            if(res.length !== 0){
                this.cardList[0].default_flag = "Y";
            }
            if(res.length == 0 && this.isBusinessRecharge){
                MessageBox({
                  title: '',
                  message: '您还未绑定银行卡，无法充值',
                  showCancelButton: false,
                  showConfirmButton:true,
                  closeOnClickModal:false,
                  confirmButtonText:'立即绑定'
                }).then(action => {
                    this.bindCard();
                })
            }
            Indicator.close();
        }).catch((error)=>{
           Toast({
                message: "code:"+error.code+" message:"+error.msg,
                duration: 3000
            });
        })
    },

    // 校验输入的金额
    validateAmount(e){
         return !e || /^(([0-9]|([1-9][0-9]*))((\.[0-9]{1,2})?))$/.test(e) && +e > 0
    },

    // 点击充值
    recharge() {
         if (!this.validateAmount(this.amount)) {
             this.amountInputWrong = true;
             this.errorText = "金额不正确";
             return;
         }

        if(this.sub(this.amount,this.selectCard.daily_single_limit) > 0){
            this.amountInputWrong = true;
            this.errorText = "当前充值上限为" + this.selectCard.daily_single_limit;
            return;
        }

        if(this.sub(this.amount,this.min_recharge_amount) < 0){
            this.amountInputWrong = true;
            this.errorText = "当前充值最低为" + this.min_recharge_amount;
            return;
        }

        Indicator.open();
        const url = '/v1/person/wallet/recharge';
        const params = {
            wallet_id:this.wallet_id,
            amount:this.amount,
            redirect:window.location.protocol + '//' + window.location.host + '/#/status',
            binding_id:this.selectCard.binding_id
        }
        if(this.bill_id !== ''){
            params.bill_id = this.bill_id;
        }
        Post(url,params).then((res)=>{
            window.location = res.recharge_grant_auth_url;
            Indicator.close();
        }).catch((error)=>{
           Toast({
                message: "code:"+error.code+" message:"+error.msg,
                duration: 3000
            });
        })
    },

    openSelectBox() {
       this.showBox = true;
    },
    closeSelectBox(){
      this.showBox = false;
    },

    // 选择银行卡
    selectCardAction(index){
      this.closeSelectBox();
      this.cardList = this.cardList.map((e)=>{
          e.default_flag = "N";
          return e;
      })
      this.cardList[index].default_flag = "Y";
    },

    // 绑定新卡
    bindCard(){
       const url = '/v1/person/wallet/card/bind';
       const params = {
           wallet_id:this.wallet_id,
           redirect:window.location.href
       }
       Indicator.open();
       Post(url,params).then((res)=>{
           Indicator.close();
           window.location = res.bank_card_bind_url;
       }).catch((error)=>{
           Toast({
                message: "code:"+error.code+" message:"+error.msg,
                duration: 3000
            });
       })
    },

    // 获取固定输入金额
    getFixedAmount(){
        const url = '/v1/person/wallet/recharge_withdraw_info';
        const params = {
            bill_id:this.bill_id,
        }
        Post(url,params).then((res)=>{
            this.amount = res.amount;
            // this.redirect = res.redirect;
            this.disableAmountInput = true;       
        }).catch((error)=>{
            Toast({
                 message: "code:"+error.code+" message:"+error.msg,
                 duration: 3000
             });
        })
    }
  },
  components: {
      dialogLimit
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.accountExtract{
  text-align: left;
}
.wrap-card-w {
    padding: .2rem .15rem .1rem;
}
.wrap-card-header {
    font-size: 18px;
    color: #5a626e;
    margin-bottom: 5px;
}
.wrap-card-header .color-link {
    font-size: 14px;
    line-height: 28px;
}
.f-rt {
    float: right;
}
.color-link {
    color: #48a0ff!important;
}

.wrap-card-w .card {
    position: relative;
    width: 100%;
    height: 1rem;
    background: #fff;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    -o-border-radius: 6px;
    border-radius: 6px;
    box-shadow: 0 2px 3px 1px rgba(0,0,0,.04);
    padding: .2rem;
    margin-bottom: .1rem;
}
.wrap-card-w .card .card-name {
    color: #66748a;
}
.banklogo-jianshe, .card.card-jianshe .icon-banklogo {
    background-position: 0 -400px;
    height: 50px;
    width: 50px;
}
.wrap-card-w .card .card-num {
    color: #97a4b8;
    font-size: 18px;
    margin-top: .1rem;
}
.wrap-card-w .card .el-rt {
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    transform: translateY(-50%);
    right: .2rem;
}
.icon-arrow-rt {
    display: inline-block;
    font-size: 12px;
    background: url('../assets/rightArrow.png') no-repeat;
    width: .15rem;
    height: .15rem;
    background-size: contain;
    margin-bottom: -0.12rem;
    margin-left: 0.02rem;
}
.list {
    position: relative;
    background-color: #fff;
    overflow: hidden;
    text-align: left;
}
.board:before, .list:before, .otpLine .otp:before, .pop-content:before, .tab:before, .wrap-table:before {
    content: "";
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    height: 300%;
    width: 300%;
    pointer-events: none;
    -webkit-transform: scale(.33333);
    -moz-transform: scale(.33333);
    transform: scale(.33333);
    -webkit-transform-origin: 0 0;
    -moz-transform-origin: 0 0;
    transform-origin: 0 0;
    border-top: 1px solid #f1f1f1;
    border-right: 0 solid #f1f1f1;
    border-bottom: 0 solid #f1f1f1;
    border-left: 0 solid #f1f1f1;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -o-border-radius: 0;
    border-radius: 0;
}
.item {
    padding-left: .15rem;
    padding-right: .15rem;
    position: relative;
    overflow: visible;
    display: block;
}
.item-md {
    height: .5rem;
    line-height: .5rem;
}
.list-input .item {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    align-items: center;
}
.list-input .label-lg {
    -webkit-flex: 0 0 4.2em;
    -moz-flex: 0 0 4.2em;
    -ms-flex: 0 0 4.2em;
    flex: 0 0 4.2em;
    width: 4.2em;
}
.list-input .label-lg, .list-input .label-xl {
    -webkit-box-flex: 0;
    -moz-box-flex: 0;
    display: block;
    color: #657389;
    margin-right: .19rem;
}
.list input {
    background: transparent;
}
.list-input .input-fake, .list-input input {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -moz-box-flex: 1;
    -moz-flex: 1;
    -ms-flex: 1;
    flex: 1;
    overflow: hidden;
    color: #657389;
    padding: 0;
    text-indent: 0;
    display: block;
    width: 100%;
}
.board:after, .btn-show:after, .credit-tem .tem-credit:after, .item:not(:last-child):after, .list:after, .tab:after {
    content: "";
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    height: 300%;
    width: 300%;
    pointer-events: none;
    -webkit-transform: scale(.33333);
    -moz-transform: scale(.33333);
    transform: scale(.33333);
    -webkit-transform-origin: 0 0;
    -moz-transform-origin: 0 0;
    transform-origin: 0 0;
    border-top: 0 solid #f1f1f1;
    border-right: 0 solid #f1f1f1;
    border-bottom: 1px solid #f1f1f1;
    border-left: 0 solid #f1f1f1;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -o-border-radius: 0;
    border-radius: 0;
}
.bar-notice-inset, .bar-warning-inset {
    padding: .06rem .15rem;
    background-color: #fb6868;
    color: #fff;
    font-size: 14px;
    vertical-align: middle;
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    -webkit-align-items: baseline;
    -moz-align-items: baseline;
    align-items: baseline;
    overflow: visible!important;
}
.bar-notice-inset {
    background-color: #abc0e0;
}
.bar-notice-inset, .bar-warning-inset {
    font-size: 14px;
}
.list-input .item {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    -moz-align-items: center;
    align-items: center;
}
.bar-notice-inset.bar-inset-lg, .bar-warning-inset.bar-inset-lg {
    display: block;
}
.bar-notice-inset:before, .bar-warning-inset:before {
    content: "";
    display: block;
    border-bottom: .07rem solid #fb6868;
    border-right: .05rem solid transparent;
    border-left: .05rem solid transparent;
    position: absolute;
    top: -.05rem;
    left: 3em;
}
.bar-notice-inset:before {
    content: "";
    display: block;
    border-bottom: .07rem solid #abc0e0;
    border-right: .05rem solid transparent;
    border-left: .05rem solid transparent;
}
.bar-notice-inset .num, .bar-warning-inset .num {
    color: #657389;
    margin: 0 2px;
}
.wrap-btn-foot {
    margin: .3rem 0 0;
    padding: 0 .15rem;
}
.btn-md {
    background-color: #3b8aff;
    color: #fff;
    border: none;
    width: 100%;
    height: .44rem;
    line-height: .44rem;
    font-size: 16px;
}
button[disabled], html input[disabled] {
    cursor: default;
}
.btn-md:disabled {
    background-color: #cfd5de;
    cursor: not-allowed;
}
.card-tips {
    text-align: center;
    padding: .05rem;
    font-size: 14px;
    color: #97a4b8;
}


/* 弹出层  */
.mask-lg, .mask-md, .mask-toast {
    z-index: 4;
}
.mask-lg, .mask-md, .mask-toast {
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.2);
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
}
.mask-md {
    padding-top: 1.6rem;
}
.wrap-pop-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
    background: #fff;
    min-height: 3.5rem;
}
.wrap-pop-title {
    color: #5a626e;
    height: .5rem;
    line-height: .5rem;
    text-align: center;
    position: relative;
}
.wrap-pop-title .icon-arrow-lt, .wrap-pop-title .icon-close, .wrap-pop-title .icon-error {
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    transform: translateY(-50%);
    left: .15rem;
    font-size: 14px;
    color: #999;
    margin-left: 4px;
}
/* .icon-close:before, .icon-error:before {
    content: "\E618";
} */
.wrap-pop-title .icon-arrow-lt:after, .wrap-pop-title .icon-close:after, .wrap-pop-title .icon-error:after {
    content: "";
    width: 300%;
    height: 300%;
    position: absolute;
    left: -75%;
    top: -75%;
}
.wrap-pop-title:after {
    content: "";
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    height: 300%;
    width: 300%;
    pointer-events: none;
    -webkit-transform: scale(.33333);
    -moz-transform: scale(.33333);
    transform: scale(.33333);
    -webkit-transform-origin: 0 0;
    -moz-transform-origin: 0 0;
    transform-origin: 0 0;
    border-top: 0 solid #e4e4e4;
    border-right: 0 solid #e4e4e4;
    border-bottom: 1px solid #e4e4e4;
    border-left: 0 solid #e4e4e4;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -o-border-radius: 0;
    border-radius: 0;
}
.list {
    position: relative;
    background-color: #fff;
    overflow: hidden;
}
.board:before, .list:before, .otpLine .otp:before, .pop-content:before, .tab:before, .wrap-table:before {
    content: "";
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    height: 300%;
    width: 300%;
    pointer-events: none;
    -webkit-transform: scale(.33333);
    -moz-transform: scale(.33333);
    transform: scale(.33333);
    -webkit-transform-origin: 0 0;
    -moz-transform-origin: 0 0;
    transform-origin: 0 0;
    border-top: 1px solid #f1f1f1;
    border-right: 0 solid #f1f1f1;
    border-bottom: 0 solid #f1f1f1;
    border-left: 0 solid #f1f1f1;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -o-border-radius: 0;
    border-radius: 0;
}
.item-checkbox {
    padding-left: .48rem!important;
}
.item {
    padding-left: .15rem;
    padding-right: .15rem;
    position: relative;
    overflow: visible;
    display: block;
}
.item-db {
    padding-right: .15rem;
}
.wrap-pop-bottom .item-db {
    padding-top: .08rem;
    padding-bottom: .08rem;
}
.banklogo-jianshe, .card.card-jianshe .icon-banklogo {
    background-position: 0 -400px;
    height: 50px;
    width: 50px;
}
.icon-banklogo {
    vertical-align: middle;
    margin-right: 5px;
    zoom: .5;
    margin-left: -2px;
    margin-top: -6px;
}
.item .el-lt {
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    transform: translateY(-50%);
    left: .15rem;
}
.list-card .bank-name {
    color: #66748a;
    font-size: 100%;
    font-weight: normal;
}
.board .board-description-lg, .board .board-description-md, .footer-md, .footer-sm, .pop-content .description, .pop-sub-title, .result-tips, .tem-more, .text-description, .wrap-agree, .wrap-card .card-bank, .wrap-more .wrap-more-title {
    font-size: 12px;
    color: #97a4b8;
}
.item .text-description, .item .wrap-more .wrap-more-title, .wrap-more .item .wrap-more-title {
    clear: both;
}
.checkbox {
    width: .18rem;
    height: .18rem;
    display: inline-block;
    position: relative;
}
.item .el-rt {
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    transform: translateY(-50%);
    right: .15rem;
}
.list input {
    background: transparent;
}
.checkbox input {
    position: absolute;
    display: block;
    width: 0;
    height: 0;
    left: 0;
    -webkit-appearance: none;
}
.checkbox input:after, .checkbox input:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    font-size: .18rem;
}
.checkbox input:after {
    content: "";
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAUCAMAAADbT899AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABCUExURUxpcT2N/zuL/zuK/0KR/zuL/zyM/02W/zuL/zuL/z2M/zuM/zuM/z2M/zuL/z+Q/zyL/zuK/zuL/zyL/zyL/zuK/1n4Dx8AAAAVdFJOUwAm3KISwVoH+vAwaUo/jRrkga/Md2JJRWsAAACHSURBVCjPfZLbDoQgDAUBQZBV8Tb//6vbB7OrAXrempZmOsGYfnLwRss8EaLS/yQYlIEV2PvteEAa+/1ywrTcha9R8wbO3oV1Farg878wCKuKX2TdpeJneTCr+KMQ5xb+LxdspcZ/ZIAzVvhPb3LKodr3DlbVvpXluv0ltfBf/pr4Lx3t//UF39kIBlcrjQ8AAAAASUVORK5CYII=);
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: contain;
    width: 16px;
    height: 14px;
    display: inline-block;
    display: block;
    visibility: hidden;
}
.checkbox input:checked:after, .icon-pwd {
    visibility: visible;
}
.checkbox:after {
    content: "";
    position: absolute;
    top: -.1rem;
    bottom: -.11rem;
    left: -.1rem;
    right: -.19rem;
}
.board:after, .btn-show:after, .credit-tem .tem-credit:after, .item:not(:last-child):after, .list:after, .tab:after {
    content: "";
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    height: 300%;
    width: 300%;
    pointer-events: none;
    -webkit-transform: scale(.33333);
    -moz-transform: scale(.33333);
    transform: scale(.33333);
    -webkit-transform-origin: 0 0;
    -moz-transform-origin: 0 0;
    transform-origin: 0 0;
    border-top: 0 solid #f1f1f1;
    border-right: 0 solid #f1f1f1;
    border-bottom: 1px solid #f1f1f1;
    border-left: 0 solid #f1f1f1;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -o-border-radius: 0;
    border-radius: 0;
}
.item-lg {
    height: .6rem;
    line-height: .6rem;
}
.item-add {
    text-align: center;
    color: #3b8aff;
}
.icon-w-add {
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA2UExURUxpcTuL/zuK/zyM/0WO/zuM/0CN/z2L/zyK/zyM/z6N/zyL/zyL/zyL/zyN/zyL/zyL/zuK/2aeZDgAAAARdFJOUwCto4kPTx5l9XUxw0CcJr/ZewhPUAAAAN5JREFUOMuVlO0WgyAIhtWwMC197/9m56o5c9ph/OAUPfElqNS/QnaLiTnFzdIAWTWjCOu1g8wmf/Iu7ER7cD6/mLllLIOnKgZN2WDvjAN08+OsAdcw7jeDu9UCtldKbZ+55+f0xZ8kDPSocxrm6s8Xf8uCpcqesV70pEaQms4oxKAxRGA6SvBqDCl/FLg1pTWQw5Z1RHiCAmLWCfsTtCNlXfJeTjEw19Mn8xpCKxVUwvU9neFEiYtaIGqm6FhEBywblWboblAZOtn4ihZBtlKy5ZStuezCkF09wktsLC+GURBymT14pAAAAABJRU5ErkJggg==);
    height: 18px;
}
.icon-w-add, .icon-w-check {
    background-position: 0 0;
    background-repeat: no-repeat;
    background-size: contain;
    width: 18px;
    display: inline-block;
}
.item-add .icon-w-add {
    vertical-align: middle;
    margin-top: -3px;
    margin-right: 5px;
}
.board:after, .btn-show:after, .credit-tem .tem-credit:after, .item:not(:last-child):after, .list:after, .tab:after {
    content: "";
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    height: 300%;
    width: 300%;
    pointer-events: none;
    -webkit-transform: scale(.33333);
    -moz-transform: scale(.33333);
    transform: scale(.33333);
    -webkit-transform-origin: 0 0;
    -moz-transform-origin: 0 0;
    transform-origin: 0 0;
    border-top: 0 solid #f1f1f1;
    border-right: 0 solid #f1f1f1;
    border-bottom: 1px solid #f1f1f1;
    border-left: 0 solid #f1f1f1;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -o-border-radius: 0;
    border-radius: 0;
}

.item:not(:last-child):after {
    position: absolute;
    bottom: 0;
}
button, input, select, textarea {
    margin: 0;
    font-size: 100%;
    font-family: inherit;
    outline-offset: 0;
    outline-style: none;
    outline-width: 0;
    -webkit-font-smoothing: inherit;
    background-image: none;
    text-indent: 0;
    padding-left: 0;
    padding-right: 0;
    border:0;
    /* border-left:0px;border-top:0px;border-right:0px; */
}
::-webkit-input-placeholder { /* WebKit browsers */
    color:   #97a4b8;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
   color:   #97a4b8;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
   color:   #97a4b8;
}
:-ms-input-placeholder { /* Internet Explorer 10+ */
    color:   #97a4b8;
}
.wrong_amount:before {
    content: "";
    display: block;
    border-bottom: .07rem solid #fb6868;
    border-right: .05rem solid transparent;
    border-left: .05rem solid transparent;
    position: absolute;
    top: -.05rem;
    left: 3em;
}
.wrong_amount{
    background-color: #fb6868;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/Recharge.vue